export default __webpack_public_path__ + "static/media/mu.24a97352.svg";